"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const OfferRequest_1 = tslib_1.__importDefault(require("../OfferRequest"));
class MakeOfferFSRequest extends OfferRequest_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, base_models_1.Docs)({
        example: '8d76f49a-9cf1-4bd2-9953-3d6a0fd45306',
        description: 'The id of the proposition to make an offer for.',
    }),
    tslib_1.__metadata("design:type", String)
], MakeOfferFSRequest.prototype, "propositionId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7',
        description: 'Profile ID as retrieved from the Identification Service.',
    }),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.SNAKE_CASE),
    tslib_1.__metadata("design:type", String)
], MakeOfferFSRequest.prototype, "profileId", void 0);
exports.default = MakeOfferFSRequest;
